<template>
  <widget-content
    :config="config"
    variant="chart"
    @refresh="$emit('refresh')"
  >
    <component
      :is="chartComponent"
      :chart-data="chartData"
      :options="options"
      :style="styles"
    ></component>
  </widget-content>
</template>

<style lang="scss" scoped>
</style>

<script>
import { get, merge } from 'lodash'
import numeral from 'numeral'
import WidgetContent from './components/WidgetContent'
import BarChart from '@/components/charts/BarChart'
import HorizontalBarChart from '@/components/charts/HorizontalBarChart'
import LineChart from '@/components/charts/LineChart'
import PieChart from '@/components/charts/PieChart'
import DoughnutChart from '@/components/charts/DoughnutChart'
import ScatterChart from '@/components/charts/ScatterChart'

const CHART_COMPONENTS = {
  bar: BarChart,
  horizontalBar: HorizontalBarChart,
  line: LineChart,
  pie: PieChart,
  doughnut: DoughnutChart,
  scatter: ScatterChart
}

export default {
  name: 'ChartWidget',

  components: {
    WidgetContent
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    config: {
      type: Object,
      required: true
    }
  },

  computed: {
    chartType () {
      return get(this.config, 'chartType')
    },

    chartComponent () {
      return get(CHART_COMPONENTS, this.chartType)
    },

    chartData () {
      return get(this.config, 'data.chartData')
    },

    options () {
      // build any custom options
      let custom = {}

      // custom legend
      let customLabels = get(this.config, 'data.options.legend.labels.custom')
      if (customLabels && customLabels.length > 0) {
        custom.legend = {
          labels: {
            generateLabels () {
              return customLabels
            }
          }
        }
      }

      // tooltip customizations
      if (get(this.config, 'data.options.tooltips.custom')) {
        let tooltips = get(this.config, 'data.options.tooltips')
        let datasets = get(this.config, 'data.chartData.datasets')
        let labels = get(this.config, 'data.chartData.labels')

        custom.tooltips = {
          callbacks: {}
        }

        if (get(this.config, 'data.options.tooltips.custom.loadTooltipTitleFromDataset')) {
          custom.tooltips.callbacks.title = (tooltipModel) => {
            let title = ''
            if (tooltipModel.length) {
              title = datasets[tooltipModel[0].datasetIndex].label + ' (' + labels[tooltipModel[0].index] + ')'
            }
            return title
          }
        }

        if (get(this.config, 'data.options.tooltips.custom.formatTooltipLabel')) {
          custom.tooltips.callbacks.label = (tooltipModel) => {
            console.log(datasets, tooltipModel)
            let label = ''
            if (tooltipModel) {
              let set = datasets[tooltipModel.datasetIndex]
              label = numeral(set.data[tooltipModel.index]).format(set.format)
              label += ' (' + numeral(set.data[tooltipModel.index] / (set.data[0] + set.data[1])).format('0%') + ')'
              // $view.goalsTooltipIcon = set.icon
            }
            return label
          }
        }

        custom.tooltips = merge(tooltips, custom.tooltips)

        // this is actually a callback name so we need to remove it:
        custom.tooltips.custom = null
      }

      return merge(get(this.config, 'data.options'), custom)
    },

    styles () {
      return get(this.config, 'data.styles', {})
    }
  }
}
</script>
